import posthog from 'posthog-js';

const CACHE_KEY = 'lsgo_posthog_identify_cache';

const stableSerialize = (props) => {
    const keys = Object.keys(props || {}).sort();
    const ordered = {};
    keys.forEach((key) => {
        ordered[key] = props[key];
    });
    return JSON.stringify(ordered);
};

/**
 * Identify a teacher in PostHog only when the distinct id or person properties change.
 * Repeated identify() calls with properties emit billable `$set` events on every page load.
 */
export const identifyTeacherIfNeeded = (userId, personProperties = {}) => {
    if (userId == null || userId === '') return false;

    const distinctId = String(userId);
    const cacheValue = `${distinctId}:${stableSerialize(personProperties)}`;

    try {
        const last = sessionStorage.getItem(CACHE_KEY);
        if (last === cacheValue && String(posthog.get_distinct_id()) === distinctId) {
            return false;
        }
    } catch (e) {
        // sessionStorage can throw in restricted contexts — fall through and identify
    }

    posthog.identify(distinctId, personProperties);

    try {
        sessionStorage.setItem(CACHE_KEY, cacheValue);
    } catch (e) {
        // ignore quota / access errors
    }

    return true;
};

export const clearPosthogIdentifyCache = () => {
    try {
        sessionStorage.removeItem(CACHE_KEY);
    } catch (e) {
        // ignore
    }
};
